function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsiveWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.3,226.88s-1.69-8.95-1.69-12.09,6-22.74,6-22.74-4.69-6.76-5.08-7.26,0-1.45,1-.72a10.68,10.68,0,0,1,1.93,2.18l-2.66-5.33s0-1.29.92-1,3.19,4.44,3.19,4.44l-2.66-6.05a1.09,1.09,0,0,1,1.68-.75c.77.43,2.92,4.87,2.92,4.87l-.73-4.6s1-1.61,1.94.48c.46,1,2.41,8,2.41,8l3.43-1.72a1.09,1.09,0,0,1,1.44.44h0a1.1,1.1,0,0,1-.24,1.38c-.91.76-2.43,2.06-2.93,2.56a36.41,36.41,0,0,0-2.42,3.14l-1.22,23.24,1.22,10.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.32,256.28s8.77,9.13,9.06,10.79-20.67,28.7-23.84,31.35-9.74,9.23-9.74,9.23l-19-10.53S115.7,262.3,117,259.4s5-10.91,5-10.91.07-10.21-.43-18.17.3-11.47.72-12.66,4.09-2.1,6.79-1.58,2.37.84,2.37.84,3,14.85,3.14,15.58S136.32,256.28,136.32,256.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.87,277.22s5.78,9.4,8.52,14.82,6.36,13.39,9.53,13.85,5-4.23,5.18-5.95-2.37-5.06-3.42-12.11-3.3-20.76-3.3-20.76l-2.2-2.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.39,221.89l-1-5s.34-.32-2.37-.84-8.39.07-8.82,1.26c-.25.72-1.15,2.89,1.22,5.56A14,14,0,0,1,132.39,221.89Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.6,254.14c2.07-27.54-4.34-56.32-12.92-82C424.93,134.09,400.17,95,358.48,86c-24-5.2-48.5.37-69.11,13.39-19.82,12.53-35.28,28.71-59.64,31.85-24.65,3.17-49.94,1.89-74.72,1.89-63.7,0-115.4,66.93-102.48,136.64s73.86,118,125.56,118c46.45,0,84.67-27.87,128.8-35.36,21.88-3.71,43.85.68,65.51-4.88,25.16-6.46,48.83-21.88,62.77-44.21C444.68,288.16,449.3,271.39,450.6,254.14Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.6,254.14c2.07-27.54-4.34-56.32-12.92-82C424.93,134.09,400.17,95,358.48,86c-24-5.2-48.5.37-69.11,13.39-19.82,12.53-35.28,28.71-59.64,31.85-24.65,3.17-49.94,1.89-74.72,1.89-63.7,0-115.4,66.93-102.48,136.64s73.86,118,125.56,118c46.45,0,84.67-27.87,128.8-35.36,21.88-3.71,43.85.68,65.51-4.88,25.16-6.46,48.83-21.88,62.77-44.21C444.68,288.16,449.3,271.39,450.6,254.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.28,
    cy: 405.44,
    rx: 213.28,
    ry: 7.38,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.28,
    cy: 405.44,
    rx: 213.28,
    ry: 7.38,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.06,309.19s4.68-3.7,5.88-6.07c1-2,1.76-4.87.7-7A4,4,0,0,0,99,294.27c-2.88,1.8-3.18,7.9-2.45,10.84C96.56,305.37,98,309.22,98.06,309.19Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81,340c.2.18,3.53,2.6,3.55,2.54s1.86-5.66,1.56-8.3c-.27-2.25-1.22-5-3.29-6.25a4,4,0,0,0-5.75,1.62C49.47,332.65,52.58,337.92,54.81,340Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83,314.78s-17.13,17.68-17,39.39,17.37,39.25,17.37,39.25,17.12-17.68,17-39.4S152.83,314.78,152.83,314.78Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,367.18a6.59,6.59,0,0,0,.62-.78c1.25-1.89,2.31-4.64,1.51-6.9A4,4,0,0,0,125.1,357c-2.32,1.09-3.47,4.82-3.71,7.87-.93-.21-1.77-.37-2.48-.49l-.93-2.09c-.34-.72-.58-1.45-.87-2.18-.41-1.09-.78-2.23-1.15-3.36,1.35-.61,5.3-2.45,6.77-4.08s3-4.23,2.53-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.1,0,.74.12,1.5-.33-1.12-.66-2.24-1-3.38-.83-3.26-1.58-6.59-2.35-9.93-.16-.7-.33-1.39-.49-2.09,1.14-.5,5.43-2.46,7-4.17s3-4.23,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.11.07.87.14,1.73-.44-1.81-.9-3.61-1.42-5.38a69.66,69.66,0,0,0-3.19-8.92c.4-.18,5.48-2.37,7.19-4.27,1.52-1.67,3-4.23,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.21.25,3,.37,4a.49.49,0,0,0,0-.11,52.54,52.54,0,0,0-4.66-8.05A71,71,0,0,0,96.16,307c-1.68-1.94-3.35-3.62-4.83-5.09-.81-.79-1.57-1.5-2.28-2.15h.07c.07,0-1.58-3.78-1.71-4-1.52-2.62-6-6.79-9.31-6.07a4,4,0,0,0-2.81,5.27c.74,2.28,3.26,3.81,5.4,4.55s7,.39,8.16.29c.73.69,1.49,1.44,2.32,2.29,1.45,1.5,3.07,3.2,4.71,5.18.44.52.89,1.1,1.33,1.66-.94-.78-2.25-1.84-2.39-1.93-2.56-1.62-8.45-3.26-11.06-1.09a4,4,0,0,0-.07,6c1.71,1.68,4.65,1.88,6.89,1.55s6.5-2.95,7.41-3.53c1,1.25,1.94,2.55,2.86,4a51.92,51.92,0,0,1,4.43,8.05c.07.16.12.34.19.5-.4-.46-2.78-2.87-3-3-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.29,2.61-.09,7.74-2.68,7.94-2.78a71,71,0,0,1,2.89,8.7c.59,2.19,1.09,4.43,1.57,6.68-.53-.59-2.75-2.83-2.92-3-2.37-1.9-8-4.17-10.88-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.42,2.38,6.68,2.3,2.54-.09,7.47-2.55,7.88-2.76.22,1,.45,2,.66,3.07.69,3.35,1.37,6.72,2.14,10,.27,1.15.57,2.26.88,3.38-.84-.86-2.38-2.42-2.52-2.53-2.37-1.9-8-4.18-10.88-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.42,2.38,6.68,2.3s6.46-2.06,7.63-2.64c.51,1.86,1.07,3.7,1.69,5.48.29.76.54,1.55.86,2.27l.47,1.14-.65-.07s-.05,1.06,0,2.79c-2.49-1.78-6.08-3.31-8.42-2.23a4,4,0,0,0-1.61,5.75,6,6,0,0,0,.52.72,15.59,15.59,0,0,0,3.22,7.17c.13.15,1.82,1.71,2.71,2.49-.86-.46-1.71-.92-2.59-1.42-1.27-.7-2.59-1.49-3.88-2.24l-2-1.26c-.68-.42-1.28-.89-1.93-1.34-.94-.68-1.88-1.43-2.81-2.17.79-1.25,3.07-5,3.39-7.13s.16-5.18-1.51-6.9a4,4,0,0,0-6,0c-2.18,2.6-.56,8.5,1,11.07,0,.08.45.59.93,1.18-.89-.75-1.79-1.5-2.67-2.29-2.49-2.25-5-4.62-7.44-7l-1.56-1.47c.68-1,3.18-5,3.52-7.32s.15-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.06,0,.09.53.7,1.07,1.37-1.37-1.27-2.75-2.51-4.15-3.7a71.48,71.48,0,0,0-7.59-5.69c.24-.36,3.26-5,3.64-7.52.34-2.24.16-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.56,8.5,1.05,11.06.11.18,1.85,2.35,2.5,3.11l-.09-.07a53,53,0,0,0-8.34-4.14,70.62,70.62,0,0,0-7.89-2.62c-2.48-.69-4.8-1.17-6.84-1.58-1.12-.21-2.14-.38-3.09-.54l.06,0s-3.41-2.28-3.65-2.4c-2.71-1.35-8.74-2.35-11.11.07a4,4,0,0,0,.56,5.95c1.88,1.49,4.82,1.38,7,.82s6-3.53,7-4.27c1,.18,2,.38,3.2.63,2,.45,4.33,1,6.79,1.72l2,.65c-1.22-.13-2.89-.28-3.06-.28-3,.06-8.84,1.94-9.83,5.19a4,4,0,0,0,3.24,5c2.35.45,4.92-1,6.6-2.51s3.8-6.05,4.24-7c1.49.51,3,1.07,4.57,1.74a51.34,51.34,0,0,1,8.14,4.27c.15.1.29.22.44.31-.6-.16-3.91-.86-4.15-.88-3-.28-9,1-10.34,4.08A4,4,0,0,0,60,357.93c2.29.71,5-.45,6.84-1.77,2.12-1.51,5-6.5,5.08-6.69a69.6,69.6,0,0,1,7.21,5.66c1.7,1.5,3.35,3.09,5,4.7-.78-.2-3.86-.84-4.08-.86-3-.28-9,.95-10.34,4.07a4,4,0,0,0,2.66,5.34c2.29.72,5-.45,6.84-1.76,2.07-1.48,4.82-6.25,5-6.66.75.74,1.5,1.46,2.24,2.2,2.43,2.42,4.85,4.85,7.32,7.18.85.8,1.72,1.56,2.59,2.33-1.17-.26-3.31-.71-3.5-.72-3-.28-9,.95-10.34,4.07a4,4,0,0,0,2.67,5.34c2.28.72,5-.45,6.83-1.76s4.25-5.28,4.92-6.41c1.45,1.27,2.92,2.49,4.43,3.63.66.48,1.3,1,2,1.42l1.95,1.31c1.36.84,2.62,1.63,3.91,2.38l1.9,1.09c-1.15-.44-3-1.12-3.15-1.16-2.94-.74-9-.42-10.84,2.46A4,4,0,0,0,99,389c2.15,1.05,5,.31,7-.71,2.22-1.12,5.57-5.27,6-5.78,1.55.89,3.08,1.74,4.52,2.51,3.84,2.05,7.19,3.69,9.8,4.92,8.45,7.31,20.36,8.11,20.36,8.11s.62-14.25-7.77-23.64A29.36,29.36,0,0,0,128.41,367.18Zm-15.1,13.9c.26-.58,2.29-5.11,2.43-7.67.47-.08.94-.18,1.4-.29a33,33,0,0,0,5.25,12.55c-1.53-.73-3.2-1.54-5-2.44C116.11,382.57,114.72,381.84,113.31,381.08Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,364.45s-14.27.44-23,9.51-8.62,23.34-8.62,23.34,14.26-.44,23-9.51S190.79,364.45,190.79,364.45Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.06,309.19s4.68-3.7,5.88-6.07c1-2,1.76-4.87.7-7A4,4,0,0,0,99,294.27c-2.88,1.8-3.18,7.9-2.45,10.84C96.56,305.37,98,309.22,98.06,309.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81,340c.2.18,3.53,2.6,3.55,2.54s1.86-5.66,1.56-8.3c-.27-2.25-1.22-5-3.29-6.25a4,4,0,0,0-5.75,1.62C49.47,332.65,52.58,337.92,54.81,340Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.83,314.78s-17.13,17.68-17,39.39,17.37,39.25,17.37,39.25,17.12-17.68,17-39.4S152.83,314.78,152.83,314.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.41,367.18a6.59,6.59,0,0,0,.62-.78c1.25-1.89,2.31-4.64,1.51-6.9A4,4,0,0,0,125.1,357c-2.32,1.09-3.47,4.82-3.71,7.87-.93-.21-1.77-.37-2.48-.49l-.93-2.09c-.34-.72-.58-1.45-.87-2.18-.41-1.09-.78-2.23-1.15-3.36,1.35-.61,5.3-2.45,6.77-4.08s3-4.23,2.53-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.1,0,.74.12,1.5-.33-1.12-.66-2.24-1-3.38-.83-3.26-1.58-6.59-2.35-9.93-.16-.7-.33-1.39-.49-2.09,1.14-.5,5.43-2.46,7-4.17s3-4.23,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.11.07.87.14,1.73-.44-1.81-.9-3.61-1.42-5.38a69.66,69.66,0,0,0-3.19-8.92c.4-.18,5.48-2.37,7.19-4.27,1.52-1.67,3-4.23,2.54-6.59a4,4,0,0,0-5-3.26c-3.25,1-5.16,6.78-5.23,9.81,0,.21.25,3,.37,4a.49.49,0,0,0,0-.11,52.54,52.54,0,0,0-4.66-8.05A71,71,0,0,0,96.16,307c-1.68-1.94-3.35-3.62-4.83-5.09-.81-.79-1.57-1.5-2.28-2.15h.07c.07,0-1.58-3.78-1.71-4-1.52-2.62-6-6.79-9.31-6.07a4,4,0,0,0-2.81,5.27c.74,2.28,3.26,3.81,5.4,4.55s7,.39,8.16.29c.73.69,1.49,1.44,2.32,2.29,1.45,1.5,3.07,3.2,4.71,5.18.44.52.89,1.1,1.33,1.66-.94-.78-2.25-1.84-2.39-1.93-2.56-1.62-8.45-3.26-11.06-1.09a4,4,0,0,0-.07,6c1.71,1.68,4.65,1.88,6.89,1.55s6.5-2.95,7.41-3.53c1,1.25,1.94,2.55,2.86,4a51.92,51.92,0,0,1,4.43,8.05c.07.16.12.34.19.5-.4-.46-2.78-2.87-3-3-2.36-1.89-8-4.17-10.87-2.3a4,4,0,0,0-.72,5.93c1.51,1.85,4.41,2.38,6.67,2.29,2.61-.09,7.74-2.68,7.94-2.78a71,71,0,0,1,2.89,8.7c.59,2.19,1.09,4.43,1.57,6.68-.53-.59-2.75-2.83-2.92-3-2.37-1.9-8-4.17-10.88-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.42,2.38,6.68,2.3,2.54-.09,7.47-2.55,7.88-2.76.22,1,.45,2,.66,3.07.69,3.35,1.37,6.72,2.14,10,.27,1.15.57,2.26.88,3.38-.84-.86-2.38-2.42-2.52-2.53-2.37-1.9-8-4.18-10.88-2.31a4,4,0,0,0-.72,5.93c1.51,1.86,4.42,2.38,6.68,2.3s6.46-2.06,7.63-2.64c.51,1.86,1.07,3.7,1.69,5.48.29.76.54,1.55.86,2.27l.47,1.14-.65-.07s-.05,1.06,0,2.79c-2.49-1.78-6.08-3.31-8.42-2.23a4,4,0,0,0-1.61,5.75,6,6,0,0,0,.52.72,15.59,15.59,0,0,0,3.22,7.17c.13.15,1.82,1.71,2.71,2.49-.86-.46-1.71-.92-2.59-1.42-1.27-.7-2.59-1.49-3.88-2.24l-2-1.26c-.68-.42-1.28-.89-1.93-1.34-.94-.68-1.88-1.43-2.81-2.17.79-1.25,3.07-5,3.39-7.13s.16-5.18-1.51-6.9a4,4,0,0,0-6,0c-2.18,2.6-.56,8.5,1,11.07,0,.08.45.59.93,1.18-.89-.75-1.79-1.5-2.67-2.29-2.49-2.25-5-4.62-7.44-7l-1.56-1.47c.68-1,3.18-5,3.52-7.32s.15-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.57,8.5,1,11.06,0,.09.53.7,1.07,1.37-1.37-1.27-2.75-2.51-4.15-3.7a71.48,71.48,0,0,0-7.59-5.69c.24-.36,3.26-5,3.64-7.52.34-2.24.16-5.18-1.52-6.89a4,4,0,0,0-6,0c-2.18,2.6-.56,8.5,1.05,11.06.11.18,1.85,2.35,2.5,3.11l-.09-.07a53,53,0,0,0-8.34-4.14,70.62,70.62,0,0,0-7.89-2.62c-2.48-.69-4.8-1.17-6.84-1.58-1.12-.21-2.14-.38-3.09-.54l.06,0s-3.41-2.28-3.65-2.4c-2.71-1.35-8.74-2.35-11.11.07a4,4,0,0,0,.56,5.95c1.88,1.49,4.82,1.38,7,.82s6-3.53,7-4.27c1,.18,2,.38,3.2.63,2,.45,4.33,1,6.79,1.72l2,.65c-1.22-.13-2.89-.28-3.06-.28-3,.06-8.84,1.94-9.83,5.19a4,4,0,0,0,3.24,5c2.35.45,4.92-1,6.6-2.51s3.8-6.05,4.24-7c1.49.51,3,1.07,4.57,1.74a51.34,51.34,0,0,1,8.14,4.27c.15.1.29.22.44.31-.6-.16-3.91-.86-4.15-.88-3-.28-9,1-10.34,4.08A4,4,0,0,0,60,357.93c2.29.71,5-.45,6.84-1.77,2.12-1.51,5-6.5,5.08-6.69a69.6,69.6,0,0,1,7.21,5.66c1.7,1.5,3.35,3.09,5,4.7-.78-.2-3.86-.84-4.08-.86-3-.28-9,.95-10.34,4.07a4,4,0,0,0,2.66,5.34c2.29.72,5-.45,6.84-1.76,2.07-1.48,4.82-6.25,5-6.66.75.74,1.5,1.46,2.24,2.2,2.43,2.42,4.85,4.85,7.32,7.18.85.8,1.72,1.56,2.59,2.33-1.17-.26-3.31-.71-3.5-.72-3-.28-9,.95-10.34,4.07a4,4,0,0,0,2.67,5.34c2.28.72,5-.45,6.83-1.76s4.25-5.28,4.92-6.41c1.45,1.27,2.92,2.49,4.43,3.63.66.48,1.3,1,2,1.42l1.95,1.31c1.36.84,2.62,1.63,3.91,2.38l1.9,1.09c-1.15-.44-3-1.12-3.15-1.16-2.94-.74-9-.42-10.84,2.46A4,4,0,0,0,99,389c2.15,1.05,5,.31,7-.71,2.22-1.12,5.57-5.27,6-5.78,1.55.89,3.08,1.74,4.52,2.51,3.84,2.05,7.19,3.69,9.8,4.92,8.45,7.31,20.36,8.11,20.36,8.11s.62-14.25-7.77-23.64A29.36,29.36,0,0,0,128.41,367.18Zm-15.1,13.9c.26-.58,2.29-5.11,2.43-7.67.47-.08.94-.18,1.4-.29a33,33,0,0,0,5.25,12.55c-1.53-.73-3.2-1.54-5-2.44C116.11,382.57,114.72,381.84,113.31,381.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.79,364.45s-14.27.44-23,9.51-8.62,23.34-8.62,23.34,14.26-.44,23-9.51S190.79,364.45,190.79,364.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "153.53 373.64 167.54 361.04 166.94 360.38 153.53 372.44 153.45 355.93 153.53 355.98 165.38 338.65 164.63 338.15 153.45 354.5 153.28 314.78 152.38 314.78 152.49 341.75 143.57 334.03 142.99 334.71 152.5 342.94 152.58 362.22 139.06 350.25 138.47 350.93 152.59 363.42 152.66 380.97 142.5 373 141.95 373.71 152.67 382.12 152.72 393.42 153.62 393.41 153.53 373.63 153.53 373.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.63 378.5 139.73 378.4 138.6 388.38 132.59 381.65 132.6 381.65 131.07 369.58 130.18 369.69 131.55 380.49 116.59 363.77 115.92 364.37 126.07 375.71 119.65 375.79 119.66 376.69 126.86 376.6 133.98 384.56 123.93 384.57 123.94 385.46 134.78 385.45 141.25 392.68 134.16 393.11 134.22 394.01 142.01 393.54 146.32 398.35 146.99 397.75 139.4 389.27 140.63 378.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.48 382.06 186.41 379.64 186.23 378.75 175.56 380.92 191.11 364.76 190.47 364.14 179.91 375.1 179.35 368.7 178.46 368.78 179.09 375.96 171.69 383.65 170.92 373.63 170.03 373.7 170.85 384.52 164.12 391.51 163.17 384.48 162.28 384.6 163.33 392.33 158.85 396.99 159.49 397.61 167.38 389.41 178.22 389.83 178.25 388.93 168.22 388.55 174.48 382.05 174.48 382.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.53,
    y: 262.76,
    width: 78.63,
    height: 141.7,
    rx: 6.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,271.23h-9.79a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h9.79a1,1,0,0,1,1,1h0A1,1,0,0,1,428.28,271.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.19,391.8H388.5V271.34h16.28l1.83,1.52a3.58,3.58,0,0,0,2.28.82h28.72a3.58,3.58,0,0,0,2.36-.88l1.65-1.46h15.57Z",
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,395.51a1.57,1.57,0,1,0-1.57,1.56A1.56,1.56,0,0,0,425,395.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 367.46,
    x2: 392.46,
    y2: 367.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 372.66,
    x2: 392.46,
    y2: 372.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 377.86,
    x2: 392.46,
    y2: 377.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 383.06,
    x2: 392.46,
    y2: 383.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.5,
    y1: 388.26,
    x2: 392.46,
    y2: 388.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.5,
    y: 279.59,
    width: 61.28,
    height: 13.17,
    rx: 1.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 296.36,
    width: 61.77,
    height: 13.16,
    rx: 1.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 315.6,
    width: 61.77,
    height: 13.17,
    rx: 1.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 332.11,
    width: 61.59,
    height: 32.15,
    rx: 3.52,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.42,340.25a4.57,4.57,0,1,0-4.57,4.57A4.57,4.57,0,0,0,430.42,340.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.59,364.26H450c2,0,3.59-1.09,3.59-2.43V350.41l-17.19-8.27-12.25,14.17L414,349.4l-20.13,14.53A4.81,4.81,0,0,0,395.59,364.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.33,228.52h-6v-7L385.19,232l18.13,10.47v-7h2.51v15.34h7V232A3.5,3.5,0,0,0,409.33,228.52Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.42,372.64v-23.7h-69.8v23.7a34.31,34.31,0,0,1-7.41,21.3l-3.06,3.86h90.74l-3.05-3.86A34.32,34.32,0,0,1,272.42,372.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.33,389.23h78.38a34.34,34.34,0,0,1-4.29-16.59v-23.7h-69.8v23.7A34.22,34.22,0,0,1,198.33,389.23Z",
    style: {
      fill: "#6C63FF",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.62,
    y: 352.5,
    width: 69.8,
    height: 10.01,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.25,
    y: 146,
    width: 280.55,
    height: 210.41,
    rx: 9.29,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25,323.7H377.8a0,0,0,0,1,0,0v23.41a9.29,9.29,0,0,1-9.29,9.29h-262a9.29,9.29,0,0,1-9.29-9.29V323.7a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.36,
    y: 159.09,
    width: 252.32,
    height: 148.65,
    style: {
      fill: "#6C63FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.7,340.06a5.18,5.18,0,1,0-5.18,5.17A5.18,5.18,0,0,0,242.7,340.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.15,
    y: 397.8,
    width: 90.76,
    height: 4.23,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.46,
    y: 175.74,
    width: 220.93,
    height: 22.36,
    rx: 3.52,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.38,
    y: 240.7,
    width: 64.25,
    height: 49.51,
    rx: 3.52,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,251.61a5.59,5.59,0,1,0-5.59,5.59A5.59,5.59,0,0,0,170.9,251.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,290.21h56.76a3.75,3.75,0,0,0,3.75-3.75V268.88L175.7,256.14,162.92,278l-10.65-10.65-21,22.39A3.73,3.73,0,0,0,133.12,290.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.04,
    y: 206.62,
    width: 98.47,
    height: 22.36,
    rx: 3.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.93,
    y: 206.62,
    width: 98.47,
    height: 22.36,
    rx: 3.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 241.76,
    x2: 209.86,
    y2: 241.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 251.34,
    x2: 209.86,
    y2: 251.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 260.93,
    x2: 209.86,
    y2: 260.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 270.51,
    x2: 209.86,
    y2: 270.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 280.09,
    x2: 209.86,
    y2: 280.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.77,
    y1: 289.68,
    x2: 209.86,
    y2: 289.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.13,
    y: 168.64,
    width: 227.87,
    height: 132.04,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54,168.64a4.41,4.41,0,1,0-4.41,4.41A4.4,4.4,0,0,0,132.54,168.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,168.64a4.41,4.41,0,1,0-4.4,4.41A4.4,4.4,0,0,0,360.41,168.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,168.64a4.41,4.41,0,1,0-4.41,4.41A4.4,4.4,0,0,0,244.43,168.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,300.84a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,244.43,300.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54,300.84a4.41,4.41,0,1,0-4.41,4.4A4.4,4.4,0,0,0,132.54,300.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.41,299.24a4.41,4.41,0,1,0-4.4,4.4A4.4,4.4,0,0,0,360.41,299.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.68,249.33a56.29,56.29,0,0,0-4.19,4.29,21.08,21.08,0,0,0-2.74,3.93s-.45-.61-2.83-3.91-2.14-5.88-2.14-5.88l3.72-3.57S142.71,245.2,143.68,249.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,234.33s.37,3,1.22,3.3,3.71-.35,2.95,1.77a5.92,5.92,0,0,1-2.76,3.08s-.93,7.32-1.52,8.3-1.32,1.68-3.87.78l-4.66-1.66a18.51,18.51,0,0,1-1.85-.18c-1.14-.17-1.14,0-2.58-2.71s-3-1-1.76-4.57,2.33-5.87,4.85-7.6S149.89,234.33,149.89,234.33Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,239c.06.86-.07,1.58-.3,1.6s-.47-.67-.54-1.54.07-1.58.3-1.6S149.9,238.12,150,239Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,226.88s-1.69-8.95-1.69-12.09,6-22.74,6-22.74-4.69-6.76-5.08-7.26,0-1.45,1-.72a10.68,10.68,0,0,1,1.93,2.18l-2.66-5.33s0-1.29.92-1,3.19,4.44,3.19,4.44l-2.66-6.05a1.09,1.09,0,0,1,1.68-.75c.77.43,2.92,4.87,2.92,4.87l-.73-4.6s1-1.61,1.94.48c.46,1,2.41,8,2.41,8l3.43-1.72a1.09,1.09,0,0,1,1.44.44h0a1.1,1.1,0,0,1-.24,1.38c-.91.76-2.43,2.06-2.93,2.56a36.41,36.41,0,0,0-2.42,3.14l-1.22,23.24,1.22,10.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.54,226.62c0-2.58,0-5-.12-6.68-.29-6.36,2.24-27.89,2.24-27.89s-6,19.59-6,22.74,1.69,12.09,1.69,12.09Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.54,226.62c0-2.58,0-5-.12-6.68-.29-6.36,2.24-27.89,2.24-27.89s-6,19.59-6,22.74,1.69,12.09,1.69,12.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,226.88s-1.69-8.95-1.69-12.09,6-22.74,6-22.74-4.69-6.76-5.08-7.26,0-1.45,1-.72a10.68,10.68,0,0,1,1.93,2.18l-2.66-5.33s0-1.29.92-1,3.19,4.44,3.19,4.44l-2.66-6.05a1.09,1.09,0,0,1,1.68-.75c.77.43,2.92,4.87,2.92,4.87l-.73-4.6s1-1.61,1.94.48c.46,1,2.41,8,2.41,8l3.43-1.72a1.09,1.09,0,0,1,1.44.44h0a1.1,1.1,0,0,1-.24,1.38c-.91.76-2.43,2.06-2.93,2.56a36.41,36.41,0,0,0-2.42,3.14l-1.22,23.24,1.22,10.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35,304a8,8,0,0,0,5.13,2.55c3.14.21,29.91-4.65,29.91-4.65s6.44,5.1,6.91,5.53,1.45.09.79-.92a10.67,10.67,0,0,0-2.05-2.07l5.14,3s1.29.13,1.11-.86-4.22-3.46-4.22-3.46l5.86,3a1.09,1.09,0,0,0,.86-1.63c-.38-.79-4.67-3.22-4.67-3.22l4.54,1s1.66-.85-.36-2c-1-.52-7.81-2.93-7.81-2.93l1.93-3.31a1.08,1.08,0,0,0-.34-1.46h0a1.09,1.09,0,0,0-1.39.15c-.82.86-2.21,2.3-2.74,2.76a37.11,37.11,0,0,1-3.3,2.21l-28.65-1-5.14-1.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,256.28s8.77,9.13,9.06,10.79-20.67,28.7-23.84,31.35-9.74,9.23-9.74,9.23l-19-10.53S115.7,262.3,117,259.4s5-10.91,5-10.91.07-10.21-.43-18.17.3-11.47.72-12.66,4.09-2.1,6.79-1.58,2.37.84,2.37.84,3,14.85,3.14,15.58S136.32,256.28,136.32,256.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,261.88c1.16-2.89-1.45-5.2-4.92-8.1a6.12,6.12,0,0,1-2.07-6.65l-4.58-4.92s.29-15.9,0-22.27c0-1,0-2.3,0-3.85-1.63.28-3,.88-3.23,1.57-.42,1.19-1.22,4.69-.72,12.66s.43,18.17.43,18.17l-.71,1.53.42,3.76L99.1,290.52l13.3,8.39,19.09-19.38,2.25,4.17c1.56-2,3.11-4.05,4.54-6C137.25,270.2,136.48,263.15,137,261.88Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,261.88c1.16-2.89-1.45-5.2-4.92-8.1a6.12,6.12,0,0,1-2.07-6.65l-4.58-4.92s.29-15.9,0-22.27c0-1,0-2.3,0-3.85-1.63.28-3,.88-3.23,1.57-.42,1.19-1.22,4.69-.72,12.66s.43,18.17.43,18.17l-.71,1.53.42,3.76L99.1,290.52l13.3,8.39,19.09-19.38,2.25,4.17c1.56-2,3.11-4.05,4.54-6C137.25,270.2,136.48,263.15,137,261.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,256.28s8.77,9.13,9.06,10.79-20.67,28.7-23.84,31.35-9.74,9.23-9.74,9.23l-19-10.53S115.7,262.3,117,259.4s5-10.91,5-10.91.07-10.21-.43-18.17.3-11.47.72-12.66,4.09-2.1,6.79-1.58,2.37.84,2.37.84,3,14.85,3.14,15.58S136.32,256.28,136.32,256.28Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64,247.54a47.3,47.3,0,0,0,2,4.28c1,1.68,2.66,2.51,2.91,3.71s1.89,5.26,1.89,5.26-5.6-2.35-8.06-5.45-2.42-8.21-2.42-8.21S132.47,246.45,133.64,247.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.87,277.22s5.78,9.4,8.52,14.82,6.36,13.39,9.53,13.85,5-4.23,5.18-5.95-2.37-5.06-3.42-12.11-3.3-20.76-3.3-20.76l-2.2-2.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.29,269.74l-8.42,7.48s.76,1.24,1.86,3.08l.76-.77,9.84,18.22S138.43,280.37,137.29,269.74Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29,269.74l-8.42,7.48s.76,1.24,1.86,3.08l.76-.77,9.84,18.22S138.43,280.37,137.29,269.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.87,277.22s5.78,9.4,8.52,14.82,6.36,13.39,9.53,13.85,5-4.23,5.18-5.95-2.37-5.06-3.42-12.11-3.3-20.76-3.3-20.76l-2.2-2.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,299.94c.1-1,.47-3.94-1.22-4.48a12.93,12.93,0,0,1-4.47,3.13,19.45,19.45,0,0,1-4.86,1.48c1.78,3.09,3.64,5.57,5.37,5.82C150.1,306.36,151.94,301.66,152.1,299.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.39,221.89l-1-5s.34-.32-2.37-.84-8.39.07-8.82,1.26c-.25.72-1.15,2.89,1.22,5.56A14,14,0,0,1,132.39,221.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.47,221.47c0-.55,0-1.07,0-1.53,0-1,0-2.4,0-4-2.47.13-5,.65-5.26,1.42s-1.15,2.89,1.22,5.56A16,16,0,0,1,125.47,221.47Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,221.47c0-.55,0-1.07,0-1.53,0-1,0-2.4,0-4-2.47.13-5,.65-5.26,1.42s-1.15,2.89,1.22,5.56A16,16,0,0,1,125.47,221.47Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.39,221.89l-1-5s.34-.32-2.37-.84-8.39.07-8.82,1.26c-.25.72-1.15,2.89,1.22,5.56A14,14,0,0,1,132.39,221.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82,284.57a57.71,57.71,0,0,0-9.1-6.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,239.4s11.07-4.91,9.42-11.71-5.57-9.86-10-8.81-3.63,3.48-3.63,3.48-4.4-1.08-6.67,1.94a5.74,5.74,0,0,0-.69,6A12.48,12.48,0,0,0,127.9,237c-.79,4.26,5.32,11.93,6.73,12.67s3.09-1.29,3.09-1.29-1.34-4.3-.27-4.63,3,2.27,3,2.27,1,1.3,1.88-1.25A19.77,19.77,0,0,0,143.31,239.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,226.14s2.12,2.84-1.53,6.5-12.08,5.35-14.15,7.49-2,7.41-2,7.41",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,239.4s-5.42,2.3-5.86,4.37",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.06,398l11.12,6a.7.7,0,0,1-.26,1.32l-15.07,1.46a2.29,2.29,0,0,1-2.49-2.57l.61-4.67Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,404c-3.52.41-9,.06-12.74.68a15.21,15.21,0,0,1-5.12.23,2.28,2.28,0,0,0,2.44,1.81l15.07-1.46A.7.7,0,0,0,134.27,404Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21,397,63.6,400.6a2.06,2.06,0,0,0,0,2.94l6.65,6.38,8.15.72a1.22,1.22,0,0,0,1-2l-4.63-5.56L73,399.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,409.68c-2.86-.68-7.29-1.72-8.48-1.87-1.47-.18-5.91-5.43-7.5-7.37l-.16.16a2.06,2.06,0,0,0,0,2.94l6.65,6.38,8.15.72A1.23,1.23,0,0,0,79.74,409.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.4,302.19,98.09,289.26s-7.9,9-8.62,14c-.08.56-.14,1.15-.19,1.75a35.09,35.09,0,0,0,3.25,17.41l14.9,32.19L117,399.47l6.09-1.5-2-47.66-11.49-36.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.42 314.04 95.94 318.71 90.55 355.33 67.21 396.99 72.95 399.14 104.55 359.64 112.09 315.84 114.61 305.06",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111.42,
    y1: 322.09,
    x2: 107.18,
    y2: 350.82,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "94.11 325.35 94.44 315.88 91.18 308.7",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,301.52s-2.61,6.2-8.49,6.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "110.77 299.23 107.5 302.17 107.5 304.78 102.93 303.8 105.22 310.33 98.03 355.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.05,
    y1: 357.68,
    x2: 95.42,
    y2: 359.96,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveWeb);
export default __webpack_public_path__ + "static/media/Responsive_web.c7e2d627d88dbac7e5641fce6760f5d7.svg";
export { ForwardRef as ReactComponent };